import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-file-alternate-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0007 1.51302V4.26672C10.0007 4.64009 10.0007 4.82677 10.0733 4.96938C10.1372 5.09482 10.2392 5.19681 10.3647 5.26072C10.5073 5.33338 10.6939 5.33338 11.0673 5.33338H13.821M11.334 8.66667H6.00065M11.334 11.3333H6.00065M7.33398 6H6.00065M10.0007 1.33334H6.53398C5.41388 1.33334 4.85383 1.33334 4.426 1.55132C4.04968 1.74307 3.74372 2.04903 3.55197 2.42535C3.33398 2.85318 3.33398 3.41323 3.33398 4.53334V11.4667C3.33398 12.5868 3.33398 13.1468 3.55197 13.5747C3.74372 13.951 4.04968 14.2569 4.426 14.4487C4.85383 14.6667 5.41388 14.6667 6.53398 14.6667H10.8007C11.9208 14.6667 12.4808 14.6667 12.9086 14.4487C13.285 14.2569 13.5909 13.951 13.7827 13.5747C14.0007 13.1468 14.0007 12.5868 14.0007 11.4667V5.33334L10.0007 1.33334Z"
      [attr.stroke]="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class FileAlternateIcon extends BaseIconComponent {}
